import type React from "react";
import type { ReactNode } from "react";
import "./style.css";
import { type AlertType, InfoTypeIcon } from "~/components/icons";

interface Props {
	type: AlertType;
	withIcon?: boolean;
	children: ReactNode;
}

export const Alert: React.FC<Props> = ({ type, children, withIcon }: Props) => {
	return (
		<div className={`mt-6 t4-alert t4-alert-${type}`}>
			{withIcon && (
				<div className="flex flex-col justify-center items-center w-14">
					<InfoTypeIcon type={type} color={{ dark: "white", light: "black" }} />
				</div>
			)}
			<div className={`t4-alert-text text-xs ${withIcon ?? "pl-5"}`}>
				<span>{children}</span>
			</div>
		</div>
	);
};
